import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { DeviceSearchOptions } from '@models/custom-fields.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  constructor(private http: HttpClient) {}

  search(term: string, limit: number = 10): Observable<DeviceSearchOptions> {
    return this.http.get<DeviceSearchOptions>(StoreEndpointsConstant.DEVICE_SEARCH, {
      params: {
        searchQuery: term
      }
    });
  }
}
